import React from "react";

const services = [
  { key: "web_development", label: "Web Development" },
  { key: "app_development", label: "App Development" },
  { key: "staffing_solutions", label: "Staffing Solutions" },
  { key: "sms_whatsapp_api", label: "SMS & WhatsApp API" },
  { key: "digital_marketing", label: "Digital Marketing" },
];

const months = Array.from({ length: 12 }, (_, i) =>
  new Date(0, i).toLocaleString("default", { month: "short" })
);

const Input = ({ type = "text", placeholder, value, onChange }) => (
  <input
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    className="w-full rounded-md border border-gray-300  px-2 py-1.5 text-sm text-gray-900  placeholder-gray-400  focus:outline-none focus:ring-1 focus:ring-indigo-500"
  />
);

const Select = ({ value, onChange, options }) => (
  <select
    value={value}
    onChange={onChange}
    className="w-full rounded-md border border-gray-300  px-2 py-1.5 text-sm text-gray-900  focus:outline-none focus:ring-1 focus:ring-indigo-500"
  >
    {options.map(({ label, value }) => (
      <option key={value} value={value}>
        {label}
      </option>
    ))}
  </select>
);

const ContactFilters = ({
  selectedMonth,
  selectedYear,
  selectedDate,
  selectedNumber,
  searchQuery,
  selectedService,
  uniqueYears = [],
  handleMonthChange,
  handleYearChange,
  handleDateChange,
  handleNumberChange,
  handleSearchChange,
  handleServiceChange,
  handleResetFilters,
}) => {
  return (
    <div className="max-w-7xl mx-auto bg-white  rounded-lg shadow-md p-4">
      <h3 className="text-lg font-semibold mb-4 text-[#0D283F]  border-b border-gray-200  pb-2">
        Filter Contacts
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-4">
        <Input placeholder="Search by Name, Email, or Message" value={searchQuery} onChange={handleSearchChange} />
        <Input type="tel" placeholder="Phone Number" value={selectedNumber} onChange={handleNumberChange} />
        <Input type="date" value={selectedDate} onChange={handleDateChange} />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-4">
        <Select
          value={selectedMonth}
          onChange={handleMonthChange}
          options={[{ label: "All Months", value: "all" }, ...months.map((m, i) => ({ label: m, value: i + 1 }))]}
        />
        <Select
          value={selectedYear}
          onChange={handleYearChange}
          options={[{ label: "All Years", value: "all" }, ...uniqueYears.map((y) => ({ label: y, value: y }))]}
        />
      </div>

      <div className="mb-4">
        <p className="font-semibold mb-2 text-[#0D283F] text-lg">Filter by Services</p>
        <div className="flex flex-wrap justify-between">
          <div className="flex flex-wrap gap-4">
            {services.map(({ key, label }) => {
              const isSelected = selectedService.includes(key);
              return (
                <button
                  key={key}
                  onClick={() =>
                    handleServiceChange({ target: { value: key, checked: !isSelected } })
                  }
                  className={`text-sm px-3 py-1 rounded-full font-medium transition ${isSelected
                    ? "bg-[#0D283F] text-white shadow-sm hover:bg-[#0D283F]"
                    : "bg-gray-200 text-gray-800 hover:bg-gray-300 "
                    }`}
                >
                  {label}
                </button>
              );
            })}
          </div>
          <div className="flex justify-end">
            <button
              onClick={handleResetFilters}
              className="text-sm px-3 py-2 rounded-full bg-red-600 hover:bg-red-700 text-white font-medium transition"
            >
              Reset Filters
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ContactFilters;




